<script lang="ts">
  // A rider's photo. Riders who don't share their activities are shown as an anonymous silhouette.
  export let src: string | null = null
  export let name: string | null = null
  export let blurred = false
  export let size = 96
  export let ring = 'rgba(255,255,255,0.9)'
  export let ringWidth = 4

  $: initials = (name ?? '').split(/\s+/).filter(Boolean).slice(0, 2).map((p) => p[0]?.toUpperCase()).join('')
</script>

<div class="xr-avatar" style="width: {size}px; height: {size}px; box-shadow: 0 0 0 {ringWidth}px {ring};">
  {#if src && !blurred}
    <img class="xr-pic" {src} alt="" />
  {:else if blurred || !initials}
    <svg viewBox="0 0 24 24" width={size * 0.56} height={size * 0.56} aria-hidden="true">
      <circle cx="12" cy="8" r="4.5" fill="currentColor" opacity="0.75" />
      <path d="M3 22c0-5 4-8 9-8s9 3 9 8z" fill="currentColor" opacity="0.75" />
    </svg>
  {:else}
    <span class="xr-initials" style="font-size: {size * 0.38}px;">{initials}</span>
  {/if}
</div>

<style>
  .xr-avatar {
    position: relative;
    flex: none;
    border-radius: 50%;
    overflow: hidden;
    background: #33424a;
    color: rgba(255, 255, 255, 0.85);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .xr-pic {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    max-width: none;
  }
  .xr-initials {
    font-weight: 700;
  }
</style>
